/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Page_Pricing_DescriptionInputs */

const en_cad_page_pricing_description = /** @type {(inputs: Cad_Page_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft is free and open source. CADCraft Online Pro adds cloud drawings, version history and share links for $4.9/month or $29/year.`)
};

/**
* | output |
* | --- |
* | "CADCraft is free and open source. CADCraft Online Pro adds cloud drawings, version history and share links for $4.9/month or $29/year." |
*
* @param {Cad_Page_Pricing_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_page_pricing_description = /** @type {((inputs?: Cad_Page_Pricing_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Page_Pricing_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_page_pricing_description(inputs)
});
export { cad_page_pricing_description as "cad.page.pricing.description" }